<small class="debug">{{ me }}</small>
@if (isTouchMode) {
    <div class="touch-collection-ui">
        <div class="collection-header">
            <mat-icon class="collection-icon">collections</mat-icon>
            <div class="collection-info">
                <div class="collection-name">{{ sceneItem?.$.label || 'Collection' }}</div>
                <div class="collection-mode">{{ sceneItem?.Data?.[0]?.Collection?.[0]?.$.mode || 'slideshow' }}</div>
            </div>
        </div>

        <div class="collection-stats">
            <div class="stat-item">
                <mat-icon>photo_library</mat-icon>
                <span>{{ sceneItem?.Data?.[0]?.Collection?.[0]?.Page?.length || 0 }} {{ 'ai.items' | transloco }}</span>
            </div>
            <div class="stat-item">
                <mat-icon>timer</mat-icon>
                <span>{{ sceneItem?.Data?.[0]?.Collection?.[0]?.$.duration || '5' }}s</span>
            </div>
        </div>

        

        <!--    <div class="collection-actions">-->
        <!--      <button mat-stroked-button class="action-btn" (click)="onCollectionTimeline()">-->
        <!--        <mat-icon>timeline</mat-icon>-->
        <!--        {{ 'ai.timeline' | transloco }}-->
        <!--      </button>-->
        <!--    </div>-->

        <div class="collection-props">
            <mat-checkbox (change)="toggleUseHotkeys()" [(ngModel)]="useHotkeys">
                &nbsp;{{ 'general.useHotkeys' | transloco }}
            </mat-checkbox>
            <mat-checkbox (change)="toggleOnIdle()" [(ngModel)]="onIdle">
                &nbsp;{{ 'general.onIdle' | transloco }}
            </mat-checkbox>

            @if (onIdle) {
                <div class="input-group">
                    <mat-form-field appearance="outline" style="width: 160px;">
                        <mat-label>{{ 'ai.durationSeconds' | transloco }}</mat-label>
                        <input type="number" matInput [(ngModel)]="idleDuration" class="hide-spinners" (change)="changeIdleDuration()">
                        <mat-icon matPrefix>schedule</mat-icon>
                        <span matSuffix>sec</span>
                    </mat-form-field>
                </div>
            }
    
        </div>

    </div>
    
} @else {
    <div class="playlist_properties">
        <app-video-link style="position: fixed; top: -10px; width: 50px; height: 50px"
                        videoLink="/help/YouTube"></app-video-link>
        <div class="clearFloat"></div>
        <div class="playlist_properties">
            @if (dynamicsInitialized) {
                <div>
                    <dynamic-form
                        [fields]="uiConfigInit"
                        [ignoreValidation]="true"
                        (submit)="submit($event)">
                    </dynamic-form>
                </div>
            }
        </div>
    </div>
}
